import { useFormField } from '@frontend/design-system';

export const useYearDropdownField = () => {
  const yearDropdownFieldProps = useFormField({
    type: 'dropdown',
    value: new Date().getFullYear().toString(),
  });
  const selectedYear = parseInt(yearDropdownFieldProps.value);
  return { yearDropdownFieldProps, selectedYear };
};
